'use client';

import { FC, useMemo } from 'react';

import { AddressLocation } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { IconButton } from '@ravago/shared/radiance/components/button/components/IconButton/IconButton';
import { Link } from '@ravago/shared/radiance/components/link/components/Link/Link';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { AppUtils } from '../../../../utils/app/app.utils';

export const AddressPanel: FC<Omit<AddressLocation, 'latLng'> & { onClose: () => void }> = ({ title, details, website, onClose }) => {
   const translate = useTranslations();
   const detailParts = useMemo(() => details?.split(/\r?\n\r?\n/) ?? [], [details]);

   return (
      <Box position="absolute" direction="column" gap="sm" background="white" top={16} right={16} width="30%" spacing="md" borderRadius="sm">
         <Box justify="between">
            <Typography variant="body-highlight" color="primary">
               {title}
            </Typography>
            <IconButton icon="times" onClick={onClose} disableStateLayer showGutters={false} />
         </Box>

         {detailParts.map((part, index) => (
            <Typography key={AppUtils.getKey('address-details', index)} variant="caption">
               {part}
            </Typography>
         ))}
         {website && (
            <Link href={website} target="_blank">
               {translate('addresses.visit-website')}
            </Link>
         )}
      </Box>
   );
};
